import HttpClient from "../httpClient";
import { SamplingScheduleItem, SamplingScheduleFilter } from "../../models/types/samplingSchedules";
import { DefaultResponse, DefaultResponseContent, DefaultFilterRequest } from "../../models/types/common";

class SamplingScheduleService {
    private service = HttpClient;

    async getAll(requestData: DefaultFilterRequest<SamplingScheduleFilter>): Promise<DefaultResponseContent<SamplingScheduleItem[]>> {
        const response = await this.service.get<DefaultResponseContent<SamplingScheduleItem[]>>("/admin/SamplingSchedules/GetAll", requestData);
        return response;
    }

    async getDetail(id: string): Promise<DefaultResponse<SamplingScheduleItem>> {
        const response = await this.service.get<DefaultResponse<SamplingScheduleItem>>(`/admin/SamplingSchedules/GetDetail/${id}`);
        return response;
    }

    async createSamplingSchedule(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/SamplingSchedules/Create`, requestData);
        return response;
    }

    async updateSamplingSchedule(requestData: any): Promise<DefaultResponse<any>> {
        const response = await this.service.post<DefaultResponse<any>>(`/admin/SamplingSchedules/Update`, requestData);
        return response;
    }

    async deleteSamplingSchedule(id: number | string): Promise<DefaultResponse<any>> {
        const response = await this.service.delete<DefaultResponse<any>>(`/admin/SamplingSchedules/Delete/${id}`);
        return response;
    }

}

const samplingScheduleSvc = new SamplingScheduleService();
export default samplingScheduleSvc;
